import React from 'react';
import { Card, CardContent, CardMedia, Typography, Button, Stack, Box } from '@mui/material';
import * as ETVConstants from '../ETVConstants.js';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

class ApprovalLibraryItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { imgRatio: null };
  }

  getPreviewUrl() {
    const { item } = this.props;
    return item?.thumbnail || item?.url || '';
  }

  // item.content_ratio expected as width/height (e.g. 1.777 for 16:9).
  // fallback: natural image ratio (if loaded), else 16/9
  getAspectPaddingPercent(item) {
    const r = Number(item?.content_ratio);
    const ratio =
      (Number.isFinite(r) && r > 0)
        ? r
        : (Number.isFinite(this.state.imgRatio) && this.state.imgRatio > 0)
          ? this.state.imgRatio
          : 16 / 9;

    return `${100 / ratio}%`; // padding-top = height/width * 100
  }

  renderRow(labelKey, value) {
    if (value === null || value === undefined || value === '') return null;
    return (
      <Typography variant="body2" color="text.secondary">
        <Box component="span" sx={{ fontWeight: 600 }}>
          {ETVConstants.trans(labelKey)}:
        </Box>{' '}
        {value}
      </Typography>
    );
  }

  render() {
    const { item, onApprove } = this.props;
    if (!item) return null;

    const preview = this.getPreviewUrl();
    const padTop = this.getAspectPaddingPercent(item);

    return (
        <Card
          sx={{
            width: '100%',
            maxWidth: 420,
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
            overflow: 'hidden',
            boxSizing: 'border-box',
            boxShadow: '0 5px 16px rgba(15,23,42,0.14)',
          }}
        >
        {preview ? (
          <Box sx={{ position: 'relative', width: '100%', pt: padTop, bgcolor: 'action.hover' }}>
            <CardMedia
              component="img"
              src={preview}
              alt={item.filename || 'content'}
              onLoad={(e) => {
                const { naturalWidth, naturalHeight } = e.currentTarget;
                if (naturalWidth && naturalHeight) {
                  const imgRatio = naturalWidth / naturalHeight;
                  // avoid extra renders if unchanged
                  if (this.state.imgRatio !== imgRatio) this.setState({ imgRatio });
                }
              }}
              sx={{
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center',
              }}
            />
          </Box>
        ) : null}

        <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
            {item.description || '-'}
          </Typography>

          {this.renderRow('showing_time', item.showing_time)}
          {this.renderRow('from_date', item.from_date)}
          {this.renderRow('until_date', item.until_date || item.to_date)}
          {this.renderRow('from_time', item.from_time)}
          {this.renderRow('to_time', item.to_time)}

          <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
            <Button variant="contained" color="success" startIcon={<CheckCircleOutlineIcon/>} fullWidth onClick={() => onApprove(item.content_id, true)}>
              {ETVConstants.trans('approve') || 'approve'}
            </Button>
            <Button variant="outlined" color="error" startIcon={<HighlightOffIcon/>} fullWidth onClick={() => onApprove(item.content_id, false)}>
              {ETVConstants.trans('reject') || 'reject'}
            </Button>
          </Stack>
        </CardContent>
      </Card>
    );
  }
}

export default ApprovalLibraryItem;
